import script from "./Program.vue?vue&type=script&setup=true&lang=js"
export * from "./Program.vue?vue&type=script&setup=true&lang=js"

import "./Program.vue?vue&type=style&index=0&id=5a1d574d&lang=scss"

const __exports__ = script;

export default __exports__